/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  app.FilterApplyPopupView = app.View.extend({
    events: {
      'click .but-apply': 'applyFilters',
      'click .but-close': 'close'
    },

    additionalOptions: ['filtersView'],

    run: function () {
      this.template = app.helpers.TemplateHelper.getTemplate('#filter-apply-popup-template');
      this.listenTo(this.filtersView, 'filter-view:show-popup', this.showPopup);
      this.listenTo(this.filtersView, 'filter-view:hide-popup', this.hidePopup);
    },

    /**
     * Применение Фильтров
     * @param {Event} e Событие
     */
    applyFilters: function (e) {
      this.trigger('filter-apply-popup:apply', e);
    },

    /**
     * Триггерит событию для сброса фильтров к предыдущему состоянию
     * @param {Event} e Событие
     */
    close: function (e) {
      Backbone.trigger('reset-filters', e);
    },

    /**
     * Показывает попап
     * @param {String} openerId         Id фильтра инициатора
     * @param {Number} total            Количество отфильтрованных элементов
     * @param {String} filterSectionId  Id секции в которой находится фильтр
     */
    showPopup: function (openerId, total, filterSectionId) {
      var checkBox = $('#' + openerId),
        checkBoxOffset = checkBox.offset(),
        listItem = checkBox.parent(),
        list = listItem.closest('.section-inside'),
        listOffset = list.offset(),
        checkBoxIsAbroad = checkBoxOffset && listOffset && checkBoxOffset.top < listOffset.top,
        popupCss;
      this.$el
        .html(this.template({'total': total}))
        .removeClass('not_display');
      // Если нет элемента то отображаем вначале секции всех фильтров
      if (!checkBox.length) {
        popupCss = $('#' + filterSectionId).offset();
        // Если элемент списка отображается, показываем рядом с ним
      } else if (!listItem.hasClass('not_display') && !checkBoxIsAbroad) {
        popupCss = checkBoxOffset;
      } else {
        // Если не отображается, показываем рядом с первым элементом
        popupCss = listOffset;
      }
      if (popupCss){
        /**
         * Сдвигаем попап, чтобы стрелка показывала на opener
         * @type {number}
         */
        _.extend(popupCss, {
          'margin-left': this.filtersView.$el.width(),
          'margin-top': -1 * this.$el.outerHeight() + 43
        });
      } else {
        popupCss = {};
      }

      this.$el.css(popupCss);
    },

    /**
     * Скрывает попап
     */
    hidePopup: function () {
      this.$el.addClass('not_display');
    }
  });
})(jQuery);

}.call(window));